(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6067],{

/***/ 20662:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billing",
      function () {
        return __webpack_require__(23757);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var theme_sub_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66084);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99408);





function TopNav(param) {
    var _activeKey = param.activeKey, activeKey = _activeKey === void 0 ? "panoramic" : _activeKey;
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_sub_menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        activeKey: activeKey,
        languageCode: languageCode,
        options: [
            {
                key: "panoramic",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].panoramic,
                href: "/billing"
            },
            {
                key: "profiles",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].profiles,
                href: "/billing/profiles"
            },
            {
                key: "documents",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].documents,
                href: "/billing/documents"
            },
            {
                key: "reports",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].reports,
                href: "/billing/reports"
            }, 
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopNav);


/***/ }),

/***/ 23757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_billing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/components/auth-switch/index.js + 15 modules
var auth_switch = __webpack_require__(17343);
// EXTERNAL MODULE: ./src/components/warning-notification/index.js + 1 modules
var warning_notification = __webpack_require__(42805);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/redux/action/billing.js
var billing = __webpack_require__(52947);
// EXTERNAL MODULE: ./src/redux/reselect/billing.js
var reselect_billing = __webpack_require__(3411);
// EXTERNAL MODULE: ./src/theme/content-loader/index.js
var content_loader = __webpack_require__(52005);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/billing-profile-card/index.js
var billing_profile_card = __webpack_require__(91940);
// EXTERNAL MODULE: ./src/theme/payment-account-card/index.js
var payment_account_card = __webpack_require__(42813);
// EXTERNAL MODULE: ./src/theme/buttons/btn-border.js
var btn_border = __webpack_require__(9246);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
// EXTERNAL MODULE: ./src/theme/icons/reload.js
var reload = __webpack_require__(16490);
// EXTERNAL MODULE: ./src/theme/icons/notification.js
var notification = __webpack_require__(19245);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/theme/billing-withdrawal-card/index.js
/* eslint-disable no-nested-ternary */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 390px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 16px 16px 16px 32px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  & > .body {\n    width: 100%;\n    padding-right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  text-align: left;\n\n  ",
        "\n\n  & > .divider {\n    width: 100%;\n    height: 1px;\n    background-color: ",
        ";\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad104657-0"
})(_templateObject(), index_esm/* space */.Dh, index_esm/* border */.Cg, index_esm/* color */.$_, index_esm/* layout */.bK);
var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad104657-1"
})(_templateObject1(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh, index_esm/* position */.FK);
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad104657-2"
})(_templateObject2(), index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("colors.primary_100"));
function BillingWithdrawalCard(param) {
    var languageCode = param.languageCode, style = param.style, lastWithdrawal = param.lastWithdrawal, isWithrawAvailable = param.isWithrawAvailable;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(), clicked = ref[0], setClicked = ref[1];
    var isWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.billing;
    }).isWaiting;
    var handleRequest = function(e) {
        e.preventDefault();
        dispatch((0,billing/* postWithdrawalRequest */.uz)());
        setClicked(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bg: "white"
    }, style), {
        children: [
            isWithrawAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                        flexDirection: "row",
                        justifyContent: "space-between",
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                            alignContent: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    mr: "8px",
                                    mt: "4px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    textAlign: "left",
                                    children: translations/* default */.Z[languageCode].WithdrawalAvailableText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "body",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            textAlign: "left",
                            my: "xs",
                            fontSize: "label",
                            lineHeight: "label",
                            fontWeight: "normal",
                            color: "grey_400",
                            children: translations/* default */.Z[languageCode].WithdrawalAvailableNotes
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "wrap-btn",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                                    style: {
                                        p: 5,
                                        mr: "m",
                                        color: "primary_300"
                                    },
                                    type: "button",
                                    label: translations/* default */.Z[languageCode].WithdrawalAvailableButton,
                                    onClick: handleRequest,
                                    disabled: isWaiting || clicked
                                })
                            }),
                            clicked && /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                textAlign: "left",
                                my: "xs",
                                fontSize: "label",
                                lineHeight: "label",
                                fontWeight: "normal",
                                color: "grey_400",
                                children: translations/* default */.Z[languageCode].WithdrawalAvailableThanks
                            })
                        ]
                    })
                ]
            }),
            !isWithrawAvailable && lastWithdrawal.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                flexDirection: "row",
                justifyContent: "space-between",
                position: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    alignContent: "flex-start",
                    textAlign: "left",
                    children: [
                        lastWithdrawal.status === "requested" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    mr: "8px",
                                    mt: "4px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reload/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                    children: [
                                        translations/* default */.Z[languageCode].WithdrawalRequested1,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: lastWithdrawal.requestedAt
                                        }),
                                        ",",
                                        " ",
                                        translations/* default */.Z[languageCode].WithdrawalRequested2,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: lastWithdrawal.nextAt
                                        }),
                                        ".",
                                        " ",
                                        translations/* default */.Z[languageCode].WithdrawalRequested3
                                    ]
                                })
                            ]
                        }),
                        lastWithdrawal.status === "processed" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                            children: [
                                translations/* default */.Z[languageCode].WithdrawalProcessed1,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: lastWithdrawal.processedAt
                                }),
                                ",",
                                " ",
                                translations/* default */.Z[languageCode].WithdrawalProcessed2
                            ]
                        }),
                        lastWithdrawal.status === "failed" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    mr: "8px",
                                    mt: "4px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                    children: [
                                        translations/* default */.Z[languageCode].WithdrawalFailed1,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: lastWithdrawal.processedAt
                                        }),
                                        ",",
                                        " ",
                                        translations/* default */.Z[languageCode].WithdrawalFailed2,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: lastWithdrawal.failureDescription
                                        }),
                                        ".",
                                        " ",
                                        translations/* default */.Z[languageCode].WithdrawalFailed3
                                    ]
                                })
                            ]
                        }),
                        lastWithdrawal.status === "blocked" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    mr: "8px",
                                    mt: "4px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                    children: [
                                        translations/* default */.Z[languageCode].WithdrawalFailed1,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: lastWithdrawal.processedAt
                                        }),
                                        ",",
                                        " ",
                                        translations/* default */.Z[languageCode].WithdrawalBloked
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
}
/* harmony default export */ var billing_withdrawal_card = (BillingWithdrawalCard);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/theme/table/billing/filters.js

function filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  height: 54px;\n"
    ]);
    filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  border-radius: 12px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    filters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var filters_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94eb23ce-0"
})(filters_templateObject());
var TabBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-94eb23ce-1"
})(filters_templateObject1(), index_esm/* color */.$_, index_esm/* space */.Dh);
function Filters(param) {
    var languageCode = param.languageCode, _selected = param.selected, selected = _selected === void 0 ? "ALL" : _selected, setSelected = param.setSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(filters_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBtn, {
                onClick: function() {
                    return setSelected("ALL");
                },
                type: "button",
                py: "s",
                px: "m",
                bg: selected === "ALL" ? "grey_400" : "transparent",
                mr: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: "h3",
                    lineHeight: "h3",
                    fontWeight: selected === "DRAFT" ? "bold" : "medium",
                    color: selected === "ALL" ? "white" : "grey_400",
                    textAlign: "center",
                    children: translations/* default */.Z[languageCode].All
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBtn, {
                onClick: function() {
                    return setSelected("DRAFT");
                },
                type: "button",
                py: "s",
                px: "m",
                bg: selected === "DRAFT" ? "grey_150" : "transparent",
                mr: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: "h3",
                    lineHeight: "h3",
                    fontWeight: selected === "DRAFT" ? "bold" : "medium",
                    color: selected === "DRAFT" ? "grey_600" : "grey_400",
                    textAlign: "center",
                    children: translations/* default */.Z[languageCode].Draft
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBtn, {
                onClick: function() {
                    return setSelected("PASSIVE");
                },
                type: "button",
                py: "s",
                px: "m",
                bg: selected === "PASSIVE" ? "primary_400" : "transparent",
                mr: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: "h3",
                    lineHeight: "h3",
                    fontWeight: selected === "PASSIVE" ? "bold" : "medium",
                    color: selected === "PASSIVE" ? "white" : "grey_400",
                    textAlign: "center",
                    children: translations/* default */.Z[languageCode].Passive
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBtn, {
                onClick: function() {
                    return setSelected("ACTIVE");
                },
                type: "button",
                py: "s",
                px: "m",
                bg: selected === "ACTIVE" ? "orange_400" : "transparent",
                mr: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: "h3",
                    lineHeight: "h3",
                    fontWeight: selected === "ACTIVE" ? "bold" : "medium",
                    color: selected === "ACTIVE" ? "white" : "grey_400",
                    textAlign: "center",
                    children: translations/* default */.Z[languageCode].Active
                })
            })
        ]
    });
}
/* harmony default export */ var filters = (Filters);

// EXTERNAL MODULE: ./src/theme/table/default/index.js
var table_default = __webpack_require__(72544);
;// CONCATENATED MODULE: ./src/theme/table/billing/index.js

function billing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 12px;\n\n  & > .table-head {\n    height: 88px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 2px solid ",
        ";\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    billing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// import { useSelector } from 'react-redux';
// import { selectByFiler } from 'redux-api/reselect/config';
// import DateSelector from 'components/filters/date-selector';


var billing_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f835e144-0"
})(billing_templateObject(), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,dist_index_esm/* themeGet */.R)("space.s"));
function BillingTable(param) {
    var emptyLabel = param.emptyLabel, onChangeTable = param.onChangeTable, invoicesType = param.invoicesType, onChangeInvoicesType = param.onChangeInvoicesType, dataSource = param.dataSource, columns = param.columns, pagination = param.pagination, loading = param.loading, languageCode = param.languageCode;
    var push = (0,router.useRouter)().push;
    // const { compare, dataType, dateRange, dates } = useSelector((state) => state.filters);
    // const selectByFilter = useSelector((state) => selectByFiler(state));
    var handleClickRow = (0,react.useCallback)(function(param) {
        var id = param.id, typologyCode = param.typologyCode, status = param.status, platformDashCode = param.platformDashCode;
        return {
            onClick: function() {
                if (typologyCode === "ACTIVE" && platformDashCode === "PUBLISH") {
                    return false;
                }
                if (typologyCode === "ACTIVE") {
                    return push({
                        pathname: "/billing/active",
                        query: {
                            id: id
                        }
                    });
                }
                if (status === "DRAFT") {
                    return push({
                        pathname: "/billing/draft",
                        query: {
                            id: id
                        }
                    });
                }
                return push({
                    pathname: "/billing/passive",
                    query: {
                        id: id
                    }
                });
            },
            style: {
                cursor: typologyCode === "ACTIVE" && platformDashCode === "PUBLISH" ? "not-allowed" : "pointer"
            }
        };
    }, [
        push
    ]);
    var handleChangeInvoicesType = (0,react.useCallback)(function(value) {
        onChangeInvoicesType(value);
    }, [
        onChangeInvoicesType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(billing_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "table-head",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filters, {
                            languageCode: languageCode,
                            selected: invoicesType,
                            setSelected: handleChangeInvoicesType
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "right"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_default/* default */.Z, {
                emptyLabel: emptyLabel,
                onChangeTable: onChangeTable,
                dataSource: dataSource,
                columns: columns,
                pagination: pagination,
                loading: loading,
                onRow: handleClickRow
            })
        ]
    });
}
/* harmony default export */ var table_billing = (BillingTable);

;// CONCATENATED MODULE: ./src/theme/icons/state-passive.js


function StatePassive() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z",
                fill: "#E0F1F3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.625 8.61133H9.65625V6.64258C9.65625 6.401 9.46033 6.20508 9.21875 6.20508H8.78125C8.53967 6.20508 8.34375 6.401 8.34375 6.64258V8.61133H6.375C6.13342 8.61133 5.9375 8.80725 5.9375 9.04883V9.48633C5.9375 9.72791 6.13342 9.92383 6.375 9.92383H8.34375V11.8926C8.34375 12.1342 8.53967 12.3301 8.78125 12.3301H9.21875C9.46033 12.3301 9.65625 12.1342 9.65625 11.8926V9.92383H11.625C11.8666 9.92383 12.0625 9.72791 12.0625 9.48633V9.04883C12.0625 8.80725 11.8666 8.61133 11.625 8.61133Z",
                fill: "#0A8EA0"
            })
        ]
    });
}
/* harmony default export */ var state_passive = (StatePassive);

;// CONCATENATED MODULE: ./src/theme/icons/state-active.js


function StateActive() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z",
                fill: "#FFA66D",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.9375 9.04883C5.9375 8.80725 6.13342 8.61133 6.375 8.61133H11.625C11.8666 8.61133 12.0625 8.80725 12.0625 9.04883V9.48633C12.0625 9.72791 11.8666 9.92383 11.625 9.92383H6.375C6.13342 9.92383 5.9375 9.72791 5.9375 9.48633V9.04883Z",
                fill: "#FFA66D"
            })
        ]
    });
}
/* harmony default export */ var state_active = (StateActive);

;// CONCATENATED MODULE: ./src/theme/icons/state-draft.js


function StateDraft() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z",
                fill: "#E7E7E7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.7412 7.91312L10.3541 6.52641L10.9091 5.97173C11.1563 5.7246 11.7223 5.67556 12.0185 5.97173L12.2958 6.24907C12.592 6.54524 12.5434 7.1113 12.2958 7.35883L11.7412 7.91312ZM11.1865 8.4682L7.30292 12.3518L5.5 12.7676L5.91582 10.9647L9.79938 7.0811L11.1865 8.4682Z",
                fill: "#5E6F72"
            })
        ]
    });
}
/* harmony default export */ var state_draft = (StateDraft);

;// CONCATENATED MODULE: ./src/theme/icons/state-complete.js


function StateComplete() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z",
                fill: "#0A8EA0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1311 5.28906L7.2001 11.2201L4.8691 8.89806L3.6001 10.1671L7.2001 13.7671L14.4001 6.56706L13.1311 5.28906Z",
                fill: "white"
            })
        ]
    });
}
/* harmony default export */ var state_complete = (StateComplete);

// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
;// CONCATENATED MODULE: ./src/components/billing/panoramic/index.js
/* eslint-disable no-nested-ternary */ 


function panoramic_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > div {\n    width: 100%;\n    max-width: 2100px;\n  }\n"
    ]);
    panoramic_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function panoramic_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 390px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 16px 16px 16px 32px;\n  margin: auto;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  & > .body {\n    width: 100%;\n    padding-right: 16px;\n  }\n"
    ]);
    panoramic_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function panoramic_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  background: linear-gradient(0deg, #e0f1f3 0%, #f5fafb 72.89%);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n\n  ",
        "\n"
    ]);
    panoramic_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 8px;\n  margin-right: 16px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

















// import StatePending from 'theme/icons/state-pending';



var panoramic_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-0"
})(panoramic_templateObject(), index_esm/* space */.Dh);
var MessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-1"
})(panoramic_templateObject1(), index_esm/* space */.Dh, index_esm/* border */.Cg, index_esm/* color */.$_, index_esm/* layout */.bK);
var BillingOverview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-2"
})(panoramic_templateObject2(), index_esm/* space */.Dh);
var panoramic_Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-3"
})(_templateObject3(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh);
var Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-4"
})(_templateObject4(), index_esm/* color */.$_);
var RowPeriods = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-5"
})(_templateObject5());
var PeriodLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5db1dbd5-6"
})(_templateObject6(), function(param) {
    var disabled = param.disabled;
    return disabled ? (0,dist_index_esm/* themeGet */.R)("colors.grey_100") : (0,dist_index_esm/* themeGet */.R)("colors.primary_100");
});
function PanoramicBilling() {
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(1), offset = ref[0], setOffset = ref[1];
    var ref1 = (0,react.useState)(20), pageSize = ref1[0], setPageSize = ref1[1];
    var ref2 = (0,react.useState)("ref_date"), orderType = ref2[0], setOrderType = ref2[1];
    var ref3 = (0,react.useState)("desc"), orderDirection = ref3[0], setOrderDirection = ref3[1];
    var ref4 = (0,react.useState)({
        status: null,
        type: null
    }), invoiceType = ref4[0], setInvoiceType = ref4[1];
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return state.billing;
    }), isWaitingDocuments = ref5.isWaitingDocuments, isProfilesWaiting = ref5.isProfilesWaiting;
    var billingSummary = (0,es/* useSelector */.v9)(reselect_billing/* default */.ZP);
    var billingDocuments = (0,es/* useSelector */.v9)(reselect_billing/* selectDocuments */.aE);
    var billingProfile = (0,es/* useSelector */.v9)(reselect_billing/* selectDefaultBillingProfile */.wO);
    var lastWithdrawal = (0,es/* useSelector */.v9)(reselect_billing/* selectLastWithdrawal */.gB);
    var isWithrawAvailable = (0,es/* useSelector */.v9)(function(state) {
        return state.billing;
    }).isWithrawAvailable;
    var ref6 = (0,es/* useSelector */.v9)(profile/* default */.Z), company = ref6.payload.company;
    (0,react.useEffect)(function() {
        dispatch((0,billing/* getBillingSummaryRequest */.AK)());
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,billing/* getBillingDocumentsRequest */.Lz)({
            per_page: pageSize,
            page: offset,
            order_by: "".concat(orderType, ":").concat(orderDirection),
            status: invoiceType.status,
            typologyCode: invoiceType.type
        }));
    }, [
        dispatch,
        pageSize,
        offset,
        orderType,
        orderDirection,
        invoiceType
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,billing/* getBillingProfilesRequest */.KQ)());
        dispatch((0,billing/* isWithrawAvailableRequest */.eB)());
        dispatch((0,billing/* getLastWithdrawalRequest */._S)());
    }, [
        dispatch
    ]);
    var columns = (0,react.useMemo)(function() {
        return [
            {
                title: translations/* default */.Z[languageCode].invoice,
                width: 130,
                dataIndex: "typologyCode",
                key: "typologyCode",
                fixed: "left",
                render: function(text, record) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            record.status === "DRAFT" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(state_draft, {}) : text === "PASSIVE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(state_passive, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(state_active, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                ml: "xs",
                                fontSize: "label",
                                lineHeight: "label",
                                fontWeight: "medium",
                                color: record.status === "DRAFT" ? "grey_05" : text === "PASSIVE" ? "primary_400" : "orange_400",
                                children: record.status === "DRAFT" ? translations/* default */.Z[languageCode].DRAFT : translations/* default */.Z[languageCode][text]
                            })
                        ]
                    });
                }
            },
            {
                title: translations/* default */.Z[languageCode].number,
                dataIndex: "issuedNumber",
                key: "issuedNumber",
                width: 150,
                render: function(text) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        children: text || translations/* default */.Z[languageCode]["no available"]
                    });
                }
            },
            {
                title: translations/* default */.Z[languageCode].date,
                dataIndex: "approvedOn",
                key: "approvedOn",
                sorter: true,
                width: 150
            },
            {
                title: translations/* default */.Z[languageCode].paidOn,
                dataIndex: "paidOn",
                key: "paidOn",
                sorter: true,
                width: 150,
                render: function(date) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        children: !date ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodLabel, {
                            disabled: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "pLarge",
                                lineHeight: "pLarge",
                                fontWeight: "medium",
                                color: "grey_400",
                                children: translations/* default */.Z[languageCode].periods_unavailable
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    mr: "xs",
                                    fontSize: "pLarge",
                                    lineHeight: "pLarge",
                                    fontWeight: "bold",
                                    color: "grey_600",
                                    children: date
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(state_complete, {})
                            ]
                        })
                    });
                }
            },
            {
                title: translations/* default */.Z[languageCode].amount,
                dataIndex: "amount",
                key: "amount",
                sorter: true,
                width: 150,
                render: function(text, record) {
                    return record.invoiceType === "DRAFT" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: "pLarge",
                        lineHeight: "pLarge",
                        fontWeight: "bold",
                        color: "grey_600",
                        children: text
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                        color: record.typologyCode === "ACTIVE" ? "red_400" : "lime_400",
                        children: [
                            record.typologyCode === "ACTIVE" ? "-" : "+",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                ml: "xxs",
                                fontSize: "pLarge",
                                lineHeight: "pLarge",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: text
                            })
                        ]
                    });
                }
            },
            {
                title: translations/* default */.Z[languageCode]["Earning Periods"],
                width: 370,
                dataIndex: "periods",
                key: "periods",
                render: function(periods) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowPeriods, {
                        children: periods.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodLabel, {
                            disabled: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "pLarge",
                                lineHeight: "pLarge",
                                fontWeight: "medium",
                                color: "grey_400",
                                children: translations/* default */.Z[languageCode].periods_unavailable
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                periods.slice(0, 3).map(function(period) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodLabel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "pLarge",
                                            lineHeight: "pLarge",
                                            fontWeight: "medium",
                                            color: "primary_400",
                                            children: period
                                        })
                                    }, period);
                                }),
                                periods.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodLabel, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "pLarge",
                                        lineHeight: "pLarge",
                                        fontWeight: "medium",
                                        color: "primary_400",
                                        children: "+".concat(periods.slice(3).length)
                                    })
                                })
                            ]
                        })
                    });
                }
            }
        ];
    }, [
        languageCode
    ]);
    var handleChange = (0,react.useCallback)(function(param) {
        var current = param.pagination.current, sorter = param.sorter;
        var order = sorter.order, columnKey = sorter.columnKey;
        if (current) {
            setOffset(current);
        }
        if (order) setOrderDirection(order === "descend" ? "desc" : "asc");
        if (columnKey) setOrderType(columnKey);
    }, []);
    var handleChangeSize = (0,react.useCallback)(function(current, s) {
        setPageSize(s);
    }, []);
    var invoiceTypeParsed = (0,react.useMemo)(function() {
        if (invoiceType.status === "DRAFT") {
            return "DRAFT";
        }
        if (invoiceType.type === "PASSIVE") {
            return "PASSIVE";
        }
        if (invoiceType.type === "ACTIVE") {
            return "ACTIVE";
        }
        return "ALL";
    }, [
        invoiceType
    ]);
    var handleChangeInvoicesType = (0,react.useCallback)(function(value) {
        if (value === "DRAFT") {
            return setInvoiceType({
                status: "DRAFT",
                type: null
            });
        }
        if (value === "PASSIVE") {
            return setInvoiceType({
                status: null,
                type: "PASSIVE"
            });
        }
        if (value === "ACTIVE") {
            return setInvoiceType({
                status: null,
                type: "ACTIVE"
            });
        }
        return setInvoiceType({
            status: null,
            type: null
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Wrapper, {
        px: "l",
        py: "xs",
        my: "xs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BillingOverview, {
                    px: "l",
                    py: "m",
                    my: "s",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Flex, {
                            mr: "xxl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "h3",
                                        lineHeight: "h3",
                                        fontWeight: "bold",
                                        color: "grey_400",
                                        children: translations/* default */.Z[languageCode]["Total earned"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "h1Large",
                                        lineHeight: "h1Large",
                                        fontWeight: "bold",
                                        color: "primary_600",
                                        children: billingSummary.totalEarned === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                            width: 350,
                                            height: 108,
                                            lines: [
                                                {
                                                    x: 0,
                                                    y: 10,
                                                    rx: 5,
                                                    ry: 5,
                                                    width: 350,
                                                    height: 98
                                                }, 
                                            ]
                                        }) : billingSummary.totalEarned
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            pt: "m",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                                    flexDirection: "column",
                                    mr: "xxl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "h3",
                                            lineHeight: "h3",
                                            fontWeight: "medium",
                                            color: "grey_400",
                                            children: translations/* default */.Z[languageCode]["Estimated next payment"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "h2",
                                            lineHeight: "h2",
                                            fontWeight: "bold",
                                            color: "grey_600",
                                            children: billingSummary.estimatedPaymentOn === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                                width: 125,
                                                height: 30,
                                                lines: [
                                                    {
                                                        x: 0,
                                                        y: 5,
                                                        rx: 5,
                                                        ry: 5,
                                                        width: 125,
                                                        height: 25
                                                    }, 
                                                ]
                                            }) : billingSummary.estimatedPaymentOn
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Flex, {
                                            flexDirection: "row",
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                fontSize: "label",
                                                lineHeight: "label",
                                                fontWeight: "medium",
                                                color: "grey_400",
                                                my: "xxs",
                                                children: [
                                                    translations/* default */.Z[languageCode].Terms,
                                                    ":",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: billingSummary.paymentTerm
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                                    flexDirection: "column",
                                    mr: "xxl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "h3",
                                            lineHeight: "h3",
                                            fontWeight: "medium",
                                            color: "grey_400",
                                            children: translations/* default */.Z[languageCode]["Next invoicing"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "h2",
                                            lineHeight: "h2",
                                            fontWeight: "bold",
                                            color: "grey_600",
                                            children: billingSummary.nextInvoicing === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                                width: 125,
                                                height: 30,
                                                lines: [
                                                    {
                                                        x: 0,
                                                        y: 5,
                                                        rx: 5,
                                                        ry: 5,
                                                        width: 125,
                                                        height: 25
                                                    }, 
                                                ]
                                            }) : billingSummary.nextInvoicing
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Flex, {
                                            flexDirection: "row",
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                fontSize: "label",
                                                lineHeight: "label",
                                                fontWeight: "medium",
                                                color: "grey_400",
                                                my: "xxs",
                                                children: [
                                                    translations/* default */.Z[languageCode].Period,
                                                    ":",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: billingSummary.invoicingPeriodCode
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                                    flexDirection: "column",
                                    ml: "xxl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "h3",
                                            lineHeight: "h3",
                                            fontWeight: "medium",
                                            color: "grey_400",
                                            children: translations/* default */.Z[languageCode]["Earnings not yet invoiced"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Flex, {
                                            flexDirection: "row",
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: "h2",
                                                lineHeight: "h2",
                                                fontWeight: "bold",
                                                color: "grey_600",
                                                mr: "s",
                                                children: billingSummary.temporaryRevenuesNotBilled === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                                    width: 130,
                                                    height: 30,
                                                    lines: [
                                                        {
                                                            x: 0,
                                                            y: 5,
                                                            rx: 5,
                                                            ry: 5,
                                                            width: 130,
                                                            height: 25
                                                        }, 
                                                    ]
                                                }) : billingSummary.temporaryRevenuesNotBilled
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                                    flexDirection: "column",
                                    ml: "xxl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "h3",
                                            lineHeight: "h3",
                                            fontWeight: "medium",
                                            color: "grey_400",
                                            children: translations/* default */.Z[languageCode]["Last earnings"]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                                            flexDirection: "row",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: "h2",
                                                    lineHeight: "h2",
                                                    fontWeight: "bold",
                                                    color: "grey_600",
                                                    mr: "s",
                                                    children: billingSummary.lastEarned === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                                        width: 130,
                                                        height: 30,
                                                        lines: [
                                                            {
                                                                x: 0,
                                                                y: 5,
                                                                rx: 5,
                                                                ry: 5,
                                                                width: 130,
                                                                height: 25
                                                            }, 
                                                        ]
                                                    }) : billingSummary.lastEarned
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "bold",
                                                    color: "grey_600",
                                                    children: billingSummary.earningsPercentage === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                                        width: 50,
                                                        height: 22,
                                                        lines: [
                                                            {
                                                                x: 0,
                                                                y: 5,
                                                                rx: 5,
                                                                ry: 5,
                                                                width: 45,
                                                                height: 20
                                                            }, 
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: (0,dist_index_esm/* themeGet */.R)(billingSummary.earningsPercentage > 0 ? "colors.lime_400" : billingSummary.earningsPercentage < 0 ? "colors.red_400" : "colors.grey_600")({
                                                                        theme: theme
                                                                    })
                                                                },
                                                                children: billingSummary.earningsPercentage > 0 ? "+" : billingSummary.earningsPercentage < 0 ? "-" : ""
                                                            }),
                                                            "".concat(Math.abs(billingSummary.earningsPercentage), "%")
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "label",
                                            lineHeight: "label",
                                            fontWeight: "medium",
                                            color: "grey_400",
                                            my: "xxs",
                                            children: translations/* default */.Z[languageCode]["Compared to previous report"]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (!!isWithrawAvailable || lastWithdrawal.status !== "processed") && /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic_Flex, {
                    flexDirection: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            width: "100%",
                            paddingRight: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "grey_600",
                                my: "s",
                                children: translations/* default */.Z[languageCode].WithdrawalAvailableTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(billing_withdrawal_card, {
                                style: {
                                    mr: "xs",
                                    border: "1px solid",
                                    borderColor: "primary_200"
                                },
                                lastWithdrawal: lastWithdrawal,
                                languageCode: languageCode,
                                isWithrawAvailable: isWithrawAvailable
                            })
                        ]
                    })
                }),
                !!billingProfile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                    flexDirection: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "50%",
                                paddingRight: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "bold",
                                    color: "grey_600",
                                    my: "s",
                                    children: translations/* default */.Z[languageCode]["Billing Profile"]
                                }),
                                isProfilesWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                    width: 400,
                                    height: 150,
                                    lines: [
                                        {
                                            x: 0,
                                            y: 0,
                                            rx: 5,
                                            ry: 5,
                                            width: 400,
                                            height: 150
                                        }, 
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(billing_profile_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    style: {
                                        mr: "xs",
                                        border: "1px solid",
                                        borderColor: "primary_200"
                                    }
                                }, billingProfile), {
                                    subTitle: translations/* default */.Z[languageCode][billingProfile.billingModeCode],
                                    languageCode: languageCode
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "50%",
                                paddingLeft: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "bold",
                                    color: "grey_600",
                                    my: "s",
                                    children: translations/* default */.Z[languageCode]["Payment Method"]
                                }),
                                isProfilesWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                                    width: 400,
                                    height: 150,
                                    lines: [
                                        {
                                            x: 0,
                                            y: 0,
                                            rx: 5,
                                            ry: 5,
                                            width: 400,
                                            height: 150
                                        }, 
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_account_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    style: {
                                        mr: "xs",
                                        border: "1px solid",
                                        borderColor: "primary_200"
                                    }
                                }, billingProfile.paymentAccount), {
                                    languageCode: languageCode,
                                    paymentAccount: billingProfile.paymentAccount,
                                    edit: false
                                }))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(panoramic_Flex, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "bold",
                            color: "grey_600",
                            my: "s",
                            children: translations/* default */.Z[languageCode]["invoice list"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(table_billing, {
                            emptyLabel: translations/* default */.Z[languageCode]["no available"],
                            columns: columns,
                            dataSource: billingDocuments.data,
                            pagination: {
                                showSizeChanger: true,
                                position: "bottomCenter",
                                pageSize: pageSize,
                                total: billingDocuments.totalCount,
                                onShowSizeChange: handleChangeSize
                            },
                            total: billingDocuments.totalCount,
                            onChangeTable: handleChange,
                            invoicesType: invoiceTypeParsed,
                            onChangeInvoicesType: handleChangeInvoicesType,
                            loading: isWaitingDocuments,
                            languageCode: languageCode,
                            onRow: function(record) {
                                return {
                                    onClick: function() {
                                        if (record.typologyCode === "ACTIVE" && record.platformDashCode === "PUBLISH") {
                                            return false;
                                        }
                                        return true;
                                    },
                                    style: {
                                        cursor: record.typologyCode === "ACTIVE" && record.platformDashCode === "PUBLISH" ? "not-allowed" : "pointer"
                                    }
                                };
                            }
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var panoramic = (PanoramicBilling);

// EXTERNAL MODULE: ./src/components/billing/top-nav.js
var top_nav = __webpack_require__(73097);
// EXTERNAL MODULE: ./src/theme/header/index.js + 1 modules
var header = __webpack_require__(28116);
// EXTERNAL MODULE: ./src/theme/layouts/body.js
var body = __webpack_require__(89129);
// EXTERNAL MODULE: ./src/components/top-bar/index.js
var top_bar = __webpack_require__(32095);
;// CONCATENATED MODULE: ./src/pages/billing/index.js

function pages_billing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  min-width: 1024px;\n"
    ]);
    pages_billing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function billing_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px 0;\n"
    ]);
    billing_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var pages_billing_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e9345c5-0"
})(pages_billing_templateObject(), index_esm/* space */.Dh);
var StyledWarningNotification = (0,styled_components_browser_esm/* default */.ZP)(warning_notification/* default */.Z).withConfig({
    componentId: "sc-4e9345c5-1"
})(billing_templateObject1(), (0,dist_index_esm/* themeGet */.R)("space.l"), (0,dist_index_esm/* themeGet */.R)("space.l"));
function BillingPage() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(auth_switch/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_billing_Wrapper, {
                pb: "xxl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                        bg: "primary_50",
                        height: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        bg: "white",
                        title: translations/* default */.Z[languageCode].Billing,
                        style: {
                            bg: "white",
                            borderWidth: "0",
                            borderBottomWidth: "1px",
                            borderColor: "primary_200",
                            borderStyle: "solid"
                        },
                        componentLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            ml: "l",
                            fontSize: "h2",
                            lineHeight: "h2",
                            fontWeight: "bold",
                            color: "grey_600",
                            textAlign: "left",
                            children: translations/* default */.Z[languageCode].billing
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(top_nav/* default */.Z, {
                        activeKey: "panoramic"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWarningNotification, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(panoramic, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var pages_billing = (BillingPage);


/***/ }),

/***/ 19245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 16px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("svg").withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "width"
        ].includes(prop);
    }
}).withConfig({
    componentId: "sc-5450415e-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function Notification(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style), {
        viewBox: "0 0 16 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.2303 13.9092H4.13027V8.05918C4.13027 5.80918 5.93027 4.00918 8.18027 4.00918C10.4303 4.00918 12.2303 5.80918 12.2303 8.05918V13.9092ZM14.0303 13.0092V8.05918C14.0303 5.29618 12.1043 2.98318 9.53027 2.37118V1.75918C9.53027 1.0136 8.92586 0.40918 8.18027 0.40918C7.43469 0.40918 6.83027 1.0136 6.83027 1.75918V2.37118C4.24727 2.98318 2.33027 5.29618 2.33027 8.05918V13.0092L0.530273 14.8092V15.7092H15.8303V14.8092L14.0303 13.0092ZM8.18027 18.4092C9.17439 18.4092 9.98027 17.6033 9.98027 16.6092H6.38027C6.38027 17.6033 7.18616 18.4092 8.18027 18.4092Z",
            fill: "currentColor"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Notification);


/***/ }),

/***/ 16490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Reload(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width || "18",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.3999 10.0089H17.3879L12.9329 14.4639L8.4779 10.0089H12.5729C12.5999 8.6229 12.0779 7.2459 11.0159 6.1839C8.9099 4.0779 5.4899 4.0779 3.3839 6.1839C1.2779 8.2899 1.2779 11.7189 3.3839 13.8249C5.0399 15.4809 7.5239 15.8319 9.5219 14.8779L10.8449 16.2009C8.0999 17.8299 4.4999 17.4699 2.1059 15.0939C-0.7021 12.2859 -0.6931 7.7319 2.1149 4.9239C4.9499 2.1069 9.4769 2.0979 12.2939 4.9149C13.6979 6.3189 14.3999 8.1639 14.3999 10.0089Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Reload);


/***/ }),

/***/ 42813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15313);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5799);
/* harmony import */ var theme_icons_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64740);
/* harmony import */ var theme_icons_check__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73377);
/* harmony import */ var theme_icons_check_circle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53107);
/* harmony import */ var react_circle_flags__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9765);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5434);
/* harmony import */ var theme_icons_payments_paypal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73407);
/* harmony import */ var theme_icons_payments_ababank__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92580);
/* harmony import */ var theme_icons_payments_bank__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84378);
/* harmony import */ var theme_icons_payments_sepa__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90350);
/* harmony import */ var theme_icons_payments_sureremit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81029);
/* harmony import */ var redux_api_action_billing__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52947);
/* harmony import */ var theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25733);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99408);
/* eslint-disable no-nested-ternary */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  min-width: 390px;\n  min-height: 148px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 16px 16px 16px 32px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 22px;\n  height: 22px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  bottom: -24px;\n  right: -24px;\n  transform: rotate(45deg);\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -2px;\n  right: 2px;\n  color: #fff;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n  width: 16px;\n  height: 16px;\n  border-radius: 16px;\n  background-color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ::after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    border-radius: 12px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: ",
        "px;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





















var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .border */ .Cg, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .layout */ .bK);
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .flexbox */ .GQ, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .position */ .FK);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(theme_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2614c667-2"
})(_templateObject2());
var StyledCircleFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(react_circle_flags__WEBPACK_IMPORTED_MODULE_11__/* .CircleFlag */ .V).withConfig({
    componentId: "sc-2614c667-3"
})(_templateObject3());
var SelectedStatus = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-4"
})(_templateObject4(), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_5__/* .color */ .$_);
var WrapIcon = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-5"
})(_templateObject5());
var CircleStatus = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-6"
})(_templateObject6(), function(param) {
    var valid = param.valid;
    return !valid ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.grey_100") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.primary_100");
}, function(param) {
    var valid = param.valid;
    return !valid ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.grey_200") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.primary_400");
});
var VerifiedStatus = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2614c667-7"
})(_templateObject7(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("space.s"), function(param) {
    var verified = param.verified;
    return verified ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.primary_400") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_6__/* .themeGet */ .R)("colors.red_400");
});
function PaymentAccountCard(param) {
    var paymentAccount = param.paymentAccount, id = param.id, style = param.style, label = param.label, paymentMethodCode = param.paymentMethodCode, billingProfilesCounter = param.billingProfilesCounter, onClick = param.onClick, selected = param.selected, errors = param.errors, company = param.company, verified = param.verified;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var payee = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.billing;
    }).payee;
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var payeeResponse = payee.response;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!!(errors && (errors.paymentAccountPid || errors.countryCode))), errorPaymentCoerence = ref[0], setErrorPaymentCoerence = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (paymentAccount.paymentMethodCode === "PAYONEER") {
            dispatch((0,redux_api_action_billing__WEBPACK_IMPORTED_MODULE_20__/* .checkPayeeIdRequest */ .j9)({
                payeeId: paymentAccount.payoneer
            }));
        }
    }, [
        dispatch,
        paymentAccount
    ]);
    var paymentIcon = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        switch(paymentMethodCode){
            case "PAYPAL":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_paypal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {});
            case "ABA":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_ababank__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {});
            case "BANK":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_bank__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {});
            case "PAYONEER":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/images/logo_payoneer.png",
                    width: "64",
                    height: "35",
                    alt: "logo"
                });
            case "SEPA":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_sepa__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {});
            case "SURE_REMIT":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_payments_sureremit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {});
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
        }
    }, [
        paymentMethodCode
    ]);
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (onClick) {
            setErrorPaymentCoerence(false);
            return onClick(id);
        }
        return push({
            pathname: "/billing/summary-payment-account",
            query: {
                id: id
            }
        });
    }, [
        push,
        onClick,
        id,
        company,
        paymentMethodCode
    ]);
    var handleEdit = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return push({
            pathname: "/billing/payment-account",
            query: {
                id: id
            }
        });
    }, [
        push,
        id
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
        bg: "white"
    }, style), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Flex, {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                    flexDirection: "row",
                    alignItems: "center",
                    children: [
                        paymentIcon,
                        paymentAccount.paymentMethodCode === "PAYONEER" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircleStatus, {
                            valid: payeeResponse
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                            mx: "s",
                            flexDirection: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                                    mt: "xxs",
                                    color: billingProfilesCounter > 0 ? "grey_600" : "grey_200",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_user__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                                    ml: "xxs",
                                    fontSize: "pLarge",
                                    lineHeight: "pLarge",
                                    fontWeight: "bold",
                                    color: billingProfilesCounter > 0 ? "grey_600" : "grey_200",
                                    children: billingProfilesCounter
                                })
                            ]
                        }),
                        !!paymentAccount.countryCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCircleFlag, {
                            countryCode: paymentAccount.countryCode.toLowerCase()
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VerifiedStatus, {
                            verified: verified !== false,
                            children: verified === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_23__/* .MdBlock */ .a7d, {
                                size: 18,
                                title: "Not verified"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_check_circle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                            flexDirection: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    label: verified === false ? translations__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z[languageCode].Verify : translations__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z[languageCode].Select,
                                    style: {
                                        minWidth: "auto"
                                    },
                                    onClick: handleClick,
                                    disabled: selected
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_buttons_btn_link__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    label: translations__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z[languageCode].Edit,
                                    style: {
                                        minWidth: "auto"
                                    },
                                    onClick: function() {
                                        return handleEdit();
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                mt: "xs",
                fontSize: "h3",
                lineHeight: "h3",
                fontWeight: "bold",
                color: "grey_600",
                children: label
            }),
            paymentAccount.ownerName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                my: "xs",
                fontSize: "h3",
                lineHeight: "h3",
                fontWeight: "medium",
                color: "grey_400",
                children: paymentAccount.ownerName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedStatus, {
                display: selected || errorPaymentCoerence ? "block" : "none",
                bg: selected && !errorPaymentCoerence ? "primary_500" : selected && errorPaymentCoerence ? "red_500" : "transparent"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapIcon, {
                children: selected && !errorPaymentCoerence ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_check__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    width: "14"
                }) : selected && errorPaymentCoerence ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_23__/* .MdError */ .vVM, {
                    width: "14"
                }) : ""
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (PaymentAccountCard);


/***/ }),

/***/ 66084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n\n  & > a {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 2px;\n  height: 34px; /* Altezza adeguata per stare tra i bottoni */\n  background-color: ",
        ";\n  margin: 0 8px; /* Spazio tra gli elementi */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var TabBtn = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-c093c216-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-2"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"));
function SubMenu(param) {
    var activeKey = param.activeKey, options = param.options;
    var isConfirmed = options.length > 0 && options[1].key === "confirmed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        py: "s",
        px: "l",
        children: options.map(function(option, index) {
            var isSecondWithOnClick = index === 1 && option.onClick;
            var nextOptionExists = index < options.length - 1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    !option.onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: option.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                                type: "button",
                                py: "s",
                                px: "m",
                                bg: activeKey === option.key ? "primary_100" : "transparent",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "medium",
                                    color: activeKey === option.key ? "primary_500" : option.color ? option.color : "grey_400",
                                    textAlign: "center",
                                    children: option.title
                                })
                            })
                        })
                    }, option.key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                        type: "button",
                        py: "s",
                        px: "m",
                        bg: activeKey === option.key ? "primary_100" : (option === null || option === void 0 ? void 0 : option.bgColor) ? option === null || option === void 0 ? void 0 : option.bgColor : "transparent",
                        onClick: option.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "medium",
                            color: activeKey === option.key ? "primary_500" : (option === null || option === void 0 ? void 0 : option.color) ? option === null || option === void 0 ? void 0 : option.color : "grey_400",
                            textAlign: "center",
                            children: option.title
                        })
                    }),
                    isSecondWithOnClick && nextOptionExists && isConfirmed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalDivider, {})
                ]
            }, option.key);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SubMenu);


/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3092,1664,8098,8446,4064,280,4762,1354,9253,6535,7343,3497,2544,7234,7935,9774,2888,179], function() { return __webpack_exec__(20662); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);